/* Flamenco Legacy Academy — shared site behavior (redesign) */

// Nav: solid background after scrolling
const flaNav = document.getElementById('flaNav');
if (flaNav) {
  const onScroll = () => flaNav.classList.toggle('scrolled', window.scrollY > 20);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

// Mobile menu
const mobileToggle = document.getElementById('mobileToggle');
const mobileMenu = document.getElementById('mobileMenu');
if (mobileToggle && mobileMenu) {
  mobileToggle.addEventListener('click', () => {
    mobileToggle.classList.toggle('active');
    mobileMenu.classList.toggle('active');
    document.body.style.overflow = mobileMenu.classList.contains('active') ? 'hidden' : '';
  });
  mobileMenu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      mobileToggle.classList.remove('active');
      mobileMenu.classList.remove('active');
      document.body.style.overflow = '';
    });
  });
}

// Scroll-in animations
const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) entry.target.classList.add('visible');
  });
}, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
document.querySelectorAll('.animate-on-scroll').forEach(el => observer.observe(el));

// Smooth scroll for same-page anchors
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const href = this.getAttribute('href');
    if (href.length > 1) {
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });
});

// Sticky mobile buy bar: appears once the hero has been scrolled past
const buybar = document.getElementById('buybar');
const heroEl = document.getElementById('hero');
if (buybar && heroEl) {
  const buybarObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => buybar.classList.toggle('show', !entry.isIntersecting));
  }, { threshold: 0.1 });
  buybarObserver.observe(heroEl);
}

// Email capture forms — front-end mock only.
// TODO(Shopify port): wire to Shopify customer form / email provider (see REDESIGN-NOTES.md).
document.querySelectorAll('form[data-capture]').forEach(form => {
  form.addEventListener('submit', e => {
    e.preventDefault();
    const email = form.querySelector('input[type="email"]');
    if (!email || !email.value || !email.checkValidity()) {
      if (email) email.reportValidity();
      return;
    }
    const success = form.parentElement.querySelector('.form-success');
    if (success) success.classList.add('show');
    form.reset();
  });
});

// Print buttons (discussion guides)
document.querySelectorAll('[data-print]').forEach(btn => {
  btn.addEventListener('click', () => window.print());
});
